import React, { JSX } from 'react'
import moment from 'moment'
export interface DateTimeFieldShowProps {
    kedo: any,
    value?: string,
    deadline?: Array<{
        number: number
        type: string
        color: string
        when: string
    }> | null,
    settings?: any,
    getFormattedDate: (value: string) => string | null
    getColor: (backgroundColor: string, text: string, fontSize?: string) => JSX.Element
}

export const DateTimeFieldShow: React.FC<DateTimeFieldShowProps> = ({
    value,
    deadline,
    kedo,
    settings,
    getFormattedDate,
    getColor,
}) => {
    if (!value) {
        return null
    }

    if (typeof value === 'string' && value == "") {
        return null
    }

    if (
        settings &&
        settings.show_ago === true
    ) {
        moment.locale(kedo.utils().getI18N().language)

        return moment().diff(moment(value as string), 'years')
    }


    if (deadline) {
        const date = getFormattedDate(value as string)
        if (!date) return null

        const targetDate = moment(value)
        const currentDate = moment()
        const timeDifference = targetDate.diff(currentDate)
        const daysDifference = Math.ceil(
            timeDifference / (1000 * 3600 * 24)
        )
        const isLeapYear = (year: number) =>
            new Date(year, 1, 29).getMonth() === 1

        for (const items of deadline) {
            const { number, type, color, when } = items
            const amount = Number(number)
            let daysThreshold = 0
            const year = targetDate.year()
            const leapYear = isLeapYear(year)

            if (type === 'day') {
                daysThreshold = number
            } else if (type === 'week') {
                daysThreshold = amount * 7
            } else if (type === 'year') {
                daysThreshold = amount * (leapYear ? 366 : 365)
            }

            const isBeforeDeadline =
                (when === 'from now' || when === 'before') &&
                daysDifference >= 0 &&
                (type === 'month'
                    ? targetDate.isSameOrBefore(
                          currentDate.clone().add(amount, 'months')
                      )
                    : daysDifference <= daysThreshold)
            const isAfterDeadline =
                when === 'after' &&
                daysDifference < 0 &&
                (type === 'month'
                    ? targetDate.isSameOrBefore(
                          currentDate.clone().subtract(amount, 'months')
                      )
                    : Math.abs(daysDifference) >= daysThreshold)

            if (isBeforeDeadline) {
                return color ? getColor(color, date) : date
            } else if (isAfterDeadline) {
                return color ? getColor(color, date) : date
            }
        }

        return date
    } else {
        return getFormattedDate(value)
    }
}